import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AccordionItemData } from './accordion-item';

import './accordion-item';

@customElement('nested-accordion')
export class NestedAccordion extends LitElement {
  static styles = css`
    :host {
      display: block;
      width: 100%;
      overflow: hidden;
    }
      
  `;

  @property({ type: Array }) items: AccordionItemData[] = [];

  render() {
    return html`
      ${this.items.map(
        item => html`<accordion-item .item="${item}"></accordion-item>`
      )}
    `;
  }
}